import React, { useState } from 'react'
import { Row, Col, FormGroup, ControlLabel } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import Card from '../../../components/Cards/Card'
import { CustomDate } from '../../../components/CustomControls/CustomDateTime'
import { CustomSearchBox } from '../../../components/CustomControls/CustomSearchBox'
import { CustomSelect } from '../../../components/CustomControls/CustomSelect'
import { SecurityAuditLog } from '../../../components/Users/SecurityAuditLog'
import { securityEventTypes } from '../../../variables/Enums'
import { useSecurityAudit } from '../Hooks'

export const SecurityAuditContainer = () => {
    const { t } = useTranslation()

    const [query, setQuery] = useState({
        userName: '',
        eventType: null,
        from: null,
        to: null,
        pageSize: 10,
        pageIndex: 0,
    })

    const [logs, isLoading, totalSize] = useSecurityAudit({
        userName:  query.userName  || undefined,
        eventType: query.eventType ?? undefined,
        from:      query.from      || undefined,
        to:        query.to        || undefined,
        pageSize:  query.pageSize,
        pageIndex: query.pageIndex,
    })

    const handleSearch = (q) => {
        setQuery(prev => ({ ...prev, userName: q, pageIndex: 0 }))
    }

    const handleSelectChange = (name, option) => {
        setQuery(prev => ({ ...prev, [name]: option?.id ?? null, pageIndex: 0 }))
    }

    const handleDateChange = (name, value) => {
        const dateStr = value && typeof value === 'object' ? value.format('YYYY-MM-DD') : null
        setQuery(prev => ({ ...prev, [name]: dateStr, pageIndex: 0 }))
    }

    const handleTableChange = (_type, { page, sizePerPage }) => {
        setQuery(prev => ({ ...prev, pageIndex: page - 1, pageSize: sizePerPage }))
    }

    const selectedEventType = securityEventTypes.find(x => x.id === query.eventType) ?? null

    return (
        <Card
            tabs
            header={
                <Row>
                    <Col md={3}>
                        <ControlLabel></ControlLabel>
                        <CustomSearchBox handleSearch={handleSearch} placeholder={t('security.securityAudit.searchPlaceholder')} />
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel></ControlLabel>
                            <CustomSelect
                                name="eventType"
                                placeholder={t('security.securityAudit.eventTypeFilter')}
                                isClearable={true}
                                options={securityEventTypes}
                                value={selectedEventType}
                                onChange={handleSelectChange}
                                getOptionLabel={x => x.title}
                                getOptionValue={x => x.id}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>{t('security.securityAudit.fromDate')}</ControlLabel>
                            <CustomDate
                                name="from"
                                value={query.from}
                                onChange={handleDateChange}
                                onBlur={() => {}}
                            />
                        </FormGroup>
                    </Col>
                    <Col md={2}>
                        <FormGroup>
                            <ControlLabel>{t('security.securityAudit.toDate')}</ControlLabel>
                            <CustomDate
                                name="to"
                                value={query.to}
                                onChange={handleDateChange}
                                onBlur={() => {}}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            }
            content={
                <SecurityAuditLog
                    data={logs ?? []}
                    query={query}
                    totalSize={totalSize}
                    onTableChange={handleTableChange}
                    isLoading={isLoading}
                />
            }
        />
    )
}
